<template>
  <v-card elevation="0">
    <v-card-actions>
      <v-btn @click="dialog = true" color="error" :disabled="undone">
        Откатить изменения
      </v-btn>
    </v-card-actions>
    <v-card-text>
      <p class="red--text" v-if="undone">Изменения были отменены</p>
      <v-treeview :items="tree" item-key="name">
        <template v-slot:prepend="{ item }">
          <v-icon>
            {{ item.isGroup ? "mdi-folder" : "mdi-food" }}
          </v-icon>
        </template>
        <template v-slot:label="{ item }">
          <div v-if="!item.isGroup">
            <span>
              {{ item.name }}
            </span>
            <br />
            <span class="text--secondary">
              Ед.Измерения: {{ item.unitName }}
            </span>
          </div>

          <span v-else>
            {{ item.name }}
          </span>
        </template>
      </v-treeview>
    </v-card-text>
    <v-dialog v-model="dialog" max-width="30%">
      <v-card>
        <v-card-title> ВЫ УВЕРЕНЫ? </v-card-title>
        <v-card-actions>
          <v-btn @click="dialog = false"> Отменить </v-btn>
          <v-spacer />
          <v-btn class="error" @click="undoConfirm"> Отменить изменения </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    tree: [],
    undone: false,
    dialog: false,
  }),
  computed: {
    ...mapGetters(["uploaded", "uploadOptions", "gGroups", "SHUnits"]),
  },
  methods: {
    ...mapActions(["undoGoods"]),
    createChild(group) {
      let children = [];
      for (const good of group.goods) {
        if (good.upload) {
          children.push({
            name: good.name,
            rid: good.rid,
            isGroup: false,
            unitName: this.SHUnits.find((e) => e.rid == good.unit_rid).name,
            children: [],
          });
        }
      }
      for (const child_group of group.child_groups) {
        children.push(this.createChild(child_group));
      }
      return { name: group.name, isGroup: true, children };
    },
    async undoConfirm() {
      this.$emit("start-loading", "Откат изменений");
      this.dialog = false;
      if (await this.undoGoods()) {
        this.undone = true;
      }
      this.$emit("stop-loading");
    },
  },
  created() {
    let children = [];
    for (const group of this.uploaded) {
      children.push(this.createChild(group));
    }
    let treeRoot = {
      name: "Загруженные товары",
      children,
      isGroup: true,
    };
    this.tree = [treeRoot];
  },
};
</script>